// removed by extract-text-webpack-plugin
module.exports = {"main":"src-ui----Main-module---main---1pr64","aside":"src-ui----Main-module---aside---2qvgS","article":"src-ui----Main-module---article---3zSiP"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/Main.module.scss
// module id = 565
// module chunks = 168707334958949